/**
 * Messageries proposées par la version web. C'est aussi la liste blanche du
 * relais (functions/relay.js) : un serveur absent d'ici est injoignable.
 *
 * Outlook / Hotmail n'accepte plus de mot de passe en IMAP : la connexion
 * passe par « Se connecter avec Microsoft » (src/microsoft.js).
 *
 * SFR et La Poste n'acceptent que TLS 1.2 : leur connexion passe par
 * tunnel-tls12.js (node-forge complété) au lieu de subtls (TLS 1.3).
 */
export const FOURNISSEURS = {
  gmail: {
    label: 'Gmail / Google Workspace',
    host: 'imap.gmail.com',
    aide: 'Crée un mot de passe d’application sur ton compte Google (la validation en deux étapes doit être activée).',
    lien: 'https://myaccount.google.com/apppasswords'
  },
  outlook: {
    label: 'Outlook / Hotmail / Live',
    host: 'outlook.office365.com',
    microsoft: true,
    aide: 'Connecte-toi avec ton compte Microsoft : aucun mot de passe à créer.'
  },
  yahoo: {
    label: 'Yahoo Mail',
    host: 'imap.mail.yahoo.com',
    aide: 'Dans « Sécurité du compte », partie « Connexions externes », choisis « Créer un mot de passe d’application ».',
    lien: 'https://login.yahoo.com/account/security'
  },
  icloud: {
    label: 'iCloud Mail',
    host: 'imap.mail.me.com',
    aide: 'Dans « Connexion et sécurité », ouvre « Mots de passe pour applications » et crées-en un.',
    lien: 'https://account.apple.com/account/manage'
  },
  orange: {
    label: 'Orange',
    host: 'imap.orange.fr',
    aide: 'Utilise le mot de passe de ta messagerie Orange.'
  },
  free: {
    label: 'Free (free.fr)',
    host: 'imap.free.fr',
    aide: 'Utilise le mot de passe de ta messagerie Free.'
  },
  bbox: {
    label: 'Bbox (bbox.fr)',
    host: 'imap.bbox.fr',
    aide: 'Utilise le mot de passe de ta messagerie Bbox.'
  },
  sfr: {
    label: 'SFR',
    host: 'imap.sfr.fr',
    tls12: true,
    aide: 'Utilise le mot de passe de ta messagerie SFR.'
  },
  laposte: {
    label: 'La Poste (laposte.net)',
    host: 'imap.laposte.net',
    tls12: true,
    aide: 'Utilise le mot de passe de ta messagerie laposte.net.'
  },
  aol: {
    label: 'AOL Mail',
    host: 'imap.aol.com',
    aide: 'Dans « Sécurité du compte », choisis « Générer un mot de passe d’application ».',
    lien: 'https://login.aol.com/account/security'
  },
  gmx: {
    label: 'GMX',
    host: 'imap.gmx.com',
    aide: 'Autorise d’abord l’accès IMAP (paramètres de ta boîte GMX, « POP3 & IMAP »), puis utilise ton mot de passe.'
  },
  zoho: {
    label: 'Zoho Mail',
    host: 'imap.zoho.eu',
    aide: 'Crée un mot de passe d’application dans les paramètres de sécurité Zoho.',
    lien: 'https://accounts.zoho.eu/home#security/app_password'
  }
};

export const SERVEURS = new Set(Object.values(FOURNISSEURS).map((f) => f.host));
